<aside class="sidebar top">
  <ng-container *ngIf="user$ | async as user">
    <nav>
      <a *ngIf="canAccess(user, 'Dashboard')" [routerLink]="dashboardLink(user)" routerLinkActive="active"
        [routerLinkActiveOptions]="{ exact: false }">
        <iconify-icon icon="mdi:monitor" width="24" height="24"></iconify-icon>
        <span>DASHBOARD</span>
      </a>

      <a *ngIf="canAccess(user, 'Usuários')" routerLink="/admin/usuarios" routerLinkActive="active"
        [routerLinkActiveOptions]="{ exact: false }">
        <iconify-icon icon="mdi:account-outline" width="24" height="24"></iconify-icon>
        <span>USUÁRIOS</span>
      </a>

      <a *ngIf="canAccess(user, 'Curador')" routerLink="/admin/curador" routerLinkActive="active"
        [routerLinkActiveOptions]="{ exact: false }">
        <iconify-icon icon="mdi:trophy-outline" width="24" height="24"></iconify-icon>
        <span>CURADOR</span>
      </a>

      <a *ngIf="canAccess(user, 'Empresas')" routerLink="/admin/empresas" routerLinkActive="active"
        [routerLinkActiveOptions]="{ exact: false }">
        <iconify-icon icon="mdi:store-outline" width="24" height="24"></iconify-icon>
        <span>EMPRESAS</span>
      </a>

      <a *ngIf="canAccess(user, 'Banners')" routerLink="/admin/banners" routerLinkActive="active"
        [routerLinkActiveOptions]="{ exact: false }">
        <iconify-icon icon="mdi:layers-outline" width="24" height="24"></iconify-icon>
        <span>BANNERS</span>
      </a>

      <a *ngIf="canAccess(user, 'Financeiro')" routerLink="/admin/financeiro" routerLinkActive="active"
        [routerLinkActiveOptions]="{ exact: false }">
        <iconify-icon icon="mdi:chart-bar" width="24" height="24"></iconify-icon>
        <span>FINANCEIRO</span>
      </a>

      <a *ngIf="canAccess(user, 'Acessos')" routerLink="/admin/acessos" routerLinkActive="active"
        [routerLinkActiveOptions]="{ exact: false }">
        <iconify-icon icon="mdi:laptop" width="24" height="24"></iconify-icon>
        <span>ACESSOS</span>
      </a>
    </nav>
  </ng-container>
</aside>

